export enum PersonaSegment {
    HE = 'HE',
    SEG = 'SEG',
    PROFESSIONAL = 'PROFESSIONAL',
    SEG_INDIVIDUAL = "SEGINDIVIDUAL"
}

export enum PersonaRole {
    STUDENT = 'STUDENT',
    ADMIN = 'ADMIN',
    HOMESCHOOLER = 'HOMESCHOOLER'
}